<template>
    <div class="article-detail" :class="{'voice-bar-padding-bottom': (detail.ttsStatus || false) === 'success'}">
        <div class="loading-wrapper" v-if="isShowLoading">
          <van-loading size="24px" vertical class="loading" type="spinner">加载中...</van-loading>
        </div>
        <div class="icon-back" @click="$router.go(-1)">
            <i class="iconfont icon-fanhui"></i>
        </div>
        <div class="icon-share" @click="shareArticle">
            <i class="iconfont icon-fenxiang1"></i>
        </div>
        <div  class="icon-try" v-if="detail.tryon" @click="onTry">
            <img src="http://img.tutubox.cn/shidai.png" width="50">
        </div>
        <div class="icon-3d" v-if="detail.model" @click="on3DView">
            <img src="http://img.tutubox.cn/3dview.png" width="50">
        </div>

        <template v-if="detail.slide.length">
            <van-swipe class="slides" :autoplay="3000">
                <van-swipe-item v-for="(item, index) in detail.slide" :key="index">
                    <img-lazy :src="item | thumbnail(750, 750)" class="slide" />
                </van-swipe-item>
            </van-swipe>
        </template>

        <component :is="needStudy ? 'van-list' : 'div'"
                   :finished="isRead" @load="updateReadState"
                   :offset="-20">
            <article-main class="main" :article="detail" :hide="detail.slide.length ? 'image' : ''" />
        </component>

        <div class="product van-hairline--top mb10">
            <card-product :card="detail.buy" v-if="(detail.buy || {}).url"></card-product>
        </div>
        
        <!-- <div class="Qrcode">
          <span class="left">——</span>
          <span class="text">文章图片仅用于学习或欣赏</span>
          <span class="right">——</span>
          <img src="http://img.tutubox.cn/ArticleQrcode1.jpg" alt="">
        </div> -->

        <box-section class="comment mb10" title="评论区">
            <span slot="head-right">共有{{ detail.comment }}条评论</span>
            <div class="comment-list">
                <card-comment v-for="item in comments" :comment="item" :key="item.id" @like="onCommentLike"
                              @comment="onComment" />
                <p v-if="comments.length === 0" class="list-empty">暂无评论</p>
            </div>
        </box-section>

        

        <div class="article-bar" style="font-size: 14px;">
            <voice-bar v-if="(detail.ttsStatus || false) === 'success'" :cover="detail.thumbnail" :title="detail.name"
                       :src="detail.tts"></voice-bar>
            <article-bar :article="detail" v-show="isBarShow" @comment="onComment" />

            <comment id="comment" v-show="isCommentBoxShow" type="document"
                     :object-id="detail.id" :parent-id="commentParentId"
                     @success="onCommented" value="" :focus="isCommentBoxShow" />
        </div>
        <!--<we-chat-share :id="detail.id" :title="detail.name" :thumbnail="detail.thumbnail" :description="detail.description" :url="shareUrl"></we-chat-share>-->
    </div>
</template>

<script>
  import Comment from '@/components/Comment';
  import {getArticleDetail, getCommentList, updateCourseStudy} from '@/api/common';
  import ArticleMain from '@/components/ArticleMain';
  import ArticleBar from '@/components/ArticleBar';
  import VoiceBar from '@/components/VoiceBar';
  import ImgLazy from '@/components/ImgLazy';
  import BoxSection from '@/components/BoxSection';
  import CardComment from '@/components/CardComment';
  import CardProduct from '@/components/CardProduct';
  import {Swipe, SwipeItem, Lazyload, List, Icon, Loading } from 'vant';
  import {Share} from '@/api/wechat';
  import Vue from 'vue'
  Vue.use(Swipe).use(SwipeItem).use(Lazyload).use(List).use(Icon).use(Loading);

  export default {
    name: 'article-detail',

    components: {ArticleMain, ArticleBar, ImgLazy, BoxSection, CardComment, CardProduct, Comment, VoiceBar},

    data() {
      return {
        isRead: false,
        detail: {
          id: this.$route.params.id,
          slide: [],
          name: '',
          thumbnail: '',
          description: '',
          tts: ''
        },
        comments: [],
        isBarShow: false,
        isCommentBoxShow: false,
        commentParentId: 0,
        isShowLoading: true
      };
    },

    computed: {
      id() {
        return this.$route.params.id;
      },
      description() {
        let dscr = this.detail.description || '';
        return [dscr.substring(0, 2), dscr.substring(2)];
      },
      commentsAhead() {
        return this.comments.slice(0, 2);
      },
      isCourse() {
        return !!this.$route.query.course;
      },
      userStudy() {
        return this.$store.state.userInfo.study || [];
      },
      needStudy() {
        return this.isCourse && !!this.$store.getters.token && !this.isRead &&
          !!this.detail.name;
      },
      shareUrl() {
        return `${window.location.origin}/#/article/detail/${this.detail.id}`;
      }
    },

    watch: {
      id(id) {
        // 修复页面跳转还在监听异常
        if (this.$route.name !== 'ArticleDetail') {
          return;
        }

        if (!id) {
          this.detail = {
            id: '',
            slide: [],
            name: '',
            thumbnail: '',
            tts: ''
          };
        } else {
          this.getArticle();
        }
      }
    },

    methods: {
      onTry() {
        window.location.href = `http://tryon.gemtec.ltd${this.detail.tryon}`;
      },

      on3DView() {
        window.location.href = `http://3d.gemtec.ltd/3d-box.html?model=${this.detail.model}&thumbnail=${this.detail.thumbnail}&title=${this.detail.name}`;
      },

      // 获取文章详情
      async getArticle() {
        let detail = await getArticleDetail(this.id);
        //fixme:OSS未支持https,兼容处理
        detail.thumbnail = detail.thumbnail.replace(/(https?:)?\/\//, 'http://')
        detail.tts = detail.ttsStatus && detail.ttsStatus === 'success' && detail.tts ? detail.tts.replace(/(https?:)?\/\//, 'http://') : ''
        detail.slide.forEach((image, i)=>{
          detail.slide[i] = image.replace(/(https?:)?\/\//, 'http://')
        })
        detail.content = detail.content.replace(/(https?:)?\/\/img/ig, 'http://img')

        this.detail = detail

        document.title = this.detail.name;

        if (!this.detail.slide) this.detail.slide = [];

        // 如果是课程，检查课程学习进度
        if (this.isCourse) {
          this.isRead = !!this.checkStudyProgress(this.id);
        }

        this.isBarShow = true;
        this.comments = await getCommentList('document', this.id);
        this.isShowLoading = false;

        if (this.$isWeChat) {
          Share(this.detail.name, this.detail.thumbnail, this.detail.description, this.shareUrl);
        }
      },

      // 更新学习进度
      async updateReadState() {
        this.isRead = true;
        let course = await updateCourseStudy(this.detail, 100);

        let userStudyCourse = this.userStudy.find(item => {
          return item.documentId === course.documentId;
        });

        // 更新本地数据
        if (userStudyCourse) {
          userStudyCourse.rate = course.rate;
        } else {
          this.userStudy.push(course);
        }
      },

      // 检查学习进度
      checkStudyProgress(id) {
        let course = this.userStudy.find(item => {
          return item.documentId === id;
        });

        if (course) {
          return course.rate;
        } else {
          return 0;
        }
      },

      onComment(parentId) {
        if (this.isCommentBoxShow) {
          this.isCommentBoxShow = false;
          return;
        }

        this.commentParentId = parentId;
        this.isCommentBoxShow = true;
      },

      onCommented(data) {
        this.isCommentBoxShow = false;
        let {userId, name, avatar} = this.$store.state.userInfo;
        let comment = {
          ...data,
          userId,
          name,
          avatar,
          like: 0,
          likeUserIds: [],
          level: 0,
          createTime: new Date().toISOString().replace(/T/, ' ').replace(/\..+/, '')
        };
        if (data.parentId === 0) {
          this.$toast('已评论');
          this.comments.push(comment);
          return;
        }
        this.$toast('已回复');

        this.commentPush(comment, this.comments);
      },

      commentPush(comment, comments) {
        // 递归插入
        comments.forEach(item => {
          if (comment.parentId === item.id) {
            item.children = [comment];
            return true;
          }
          if (item.children) {
            if (this.commentPush(comment, item.children)) {
              return true;
            }
          }
        });
        return false;
      },

      onCommentLike(id) {
        this.commentLike(id, this.comments);
      },

      commentLike(id, comments) {
        // 递归
        comments.forEach(item => {
          if (id === item.id) {
            item.like++;
            item.likeUserIds.push(this.$store.state.userInfo.userId);
            return true;
          }
          if (item.children) {
            if (this.commentLike(id, item.children)) {
              return true;
            }
          }
        });
        return false;
      },

      shareArticle() {
        this.$router.push({
          name: 'TalkPublishArticle',
          params: {
            id: this.id,
            thumbnail: this.detail.thumbnail,
            description: this.detail.description,
            name: this.detail.name
          }
        })
      }
    },

    created() {
      this.getArticle();
    },

    deactivated() {
      this.isShowLoading = true;
    },
   
  };
</script>

<style lang="less" scoped>
    .loading-wrapper{
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      z-index: 99999;
      background-color: #fff;
      .loading {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%)
        }
    }
    
    .mb10 {
        margin-bottom: 10px;
    }
    .icon-back{
        position: fixed;
        font-size: 16px;
        width: 30px;
        height: 30px;
        line-height: 30px;
        top: 20px;
        left: 20px;
        z-index: 999;
        background-color:rgba(0,0,0,0.5);
        border-radius: 50%;
        text-align: center;
        .iconfont{
          font-size: 22px;
          color: #fff;
        }
    }
    .icon-share{
        position: fixed;
        width: 30px;
        height: 30px;
        line-height: 30px;
        font-size: 16px;
        top: 60px;
        left: 20px;
        z-index: 999;
        background-color:rgba(0,0,0,0.5);
        border-radius: 50%;
        text-align: center;
        .iconfont{
          font-size: 22px;
          color: #fff;           
        }
    }
    .icon-try{
        position: absolute;
        top: 20px;
        right: 78px;
        z-index: 999;
    }
    .icon-3d {
        position: absolute;
        top: 20px;
        right: 20px;
        z-index: 999;
    }

    .voice-bar-padding-bottom {
        padding-bottom: 130px;
    }

    .slides {
        width: 100%;
        height: 100vw;
        background-color: #fff;

        .slide {
            width: 100%;
            height: 100%;
        }
    }

    .slides /deep/ .van-swipe__indicator--active {
        background-color: #97835f;
        width: 20px;
        border-radius: 3px;
    }

    .slides /deep/ .img {
        background-size: cover;
    }

    .article-detail {
        background-color: #f4f8fb;
        padding-bottom: 60px;

        .main /deep/ p {
            line-height: 24px;
            color: #606266;
        }

        .main, .product, .comment {
            background-color: #fff;
        }
    }

    .start-word {
        font-size: 32px;
    }

    .comment-list {
        padding: 0 10px 0 20px;
    }

    .list-empty {
        text-align: center;
        font-size: 12px;
        padding: 20px;
        color: #999;
    }

    .list-all {
        font-size: 16px;
        padding: 12px;
        color: #999;
    }

    .article-bar {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
    }

    .Qrcode{
      padding: 5px 35px;
      text-align: center;
      background-color: #fff;
      .left{ 
        margin-right: 5px; 
      }
      .right{
        margin-left: 5px;
      }
      img{
        width: 100%;
        margin-top: 5px;
      }
    }

</style>